document
  .querySelector('.modal-overlay')
  ?.addEventListener('click', toggleBackInStockModal)

var closemodal = document.querySelectorAll('.modal-close')
for (var i = 0; i < closemodal.length; i++) {
  closemodal[i].addEventListener('click', toggleBackInStockModal)
}

document.onkeydown = function (evt) {
  evt = evt || window.event
  var isEscape = false
  if ('key' in evt) {
    isEscape = evt.key === 'Escape' || evt.key === 'Esc'
  } else {
    isEscape = evt.keyCode === 27
  }
  if (isEscape && document.body.classList.contains('modal-active')) {
    toggleBackInStockModal()
  }
}

function toggleBackInStockModal(close = true) {
  const body = document.querySelector('body')
  const modal = document.querySelector('.modal')

  if (close) {
    modal.classList.add('opacity-0')
    modal.classList.add('pointer-events-none')
    body.classList.remove('modal-active')
    if (document.querySelector('#backInStock-form__message--error').classList.contains('flex')) {
      document.querySelector('#backInStock-form__message--error').classList.toggle('invisible')
      document.querySelector('#backInStock-form__message--error').classList.toggle('hidden')
      document.querySelector('#backInStock-form__message--error').classList.toggle('flex')
    }
    if (document.querySelector('#backInStock-form__message--success').classList.contains('flex')) {
      document.querySelector('#backInStock-form__message--success').classList.toggle('invisible')
      document.querySelector('#backInStock-form__message--success').classList.toggle('hidden')
      document.querySelector('#backInStock-form__message--success').classList.toggle('flex')
    }
  } else {
    modal.classList.remove('opacity-0')
    modal.classList.remove('pointer-events-none')
    body.classList.add('modal-active')
  }

  if (document.body.classList.contains('modal-active')) {
    trapFocus(modal)
  } else {
    removeTrapFocus()
  }
}



document
  .querySelector('#notify_me_form')
  .addEventListener('submit', function (e) {
    e.preventDefault()
    function getBaseUrl(sku) {
      if (document.domain === 'shop.wantable.com') {
        return 'https://www.wantable.com/api/shopify/variants/' + sku + '/notify'
      } else {
        return 'https://staging.wantable.com/api/shopify/variants/' + sku + '/notify'
      }
    }

    let sku = document.querySelector('#backinstockForm--SKU').value
    let email = document.querySelector('#backinstockForm--Email').value

    const backInStockUrl = getBaseUrl(sku)

    let sendBackInStockRequest = new Request(backInStockUrl, {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      method: 'POST',
      body: JSON.stringify({
        email: email
      })
    })

    fetch(sendBackInStockRequest)
      .then((response) => {
        console.log(response)
        if (response.status === 200) {
          response.json().then((data) => {
            console.log(data)

            document.querySelector('#backinstockForm--Email').setAttribute('aria-describedby', 'backinstock-success')
            document.querySelector('#backInStock-form__message--success').classList.toggle('invisible')
            document.querySelector('#backInStock-form__message--success').classList.toggle('hidden')
            document.querySelector('#backInStock-form__message--success').classList.toggle('flex')

            if (document.querySelector('#backInStock-form__message--error').classList.contains('flex')) {
              document.querySelector('#backInStock-form__message--error').classList.toggle('invisible')
              document.querySelector('#backInStock-form__message--error').classList.toggle('hidden')
              document.querySelector('#backInStock-form__message--error').classList.toggle('flex')
            }
          })
        } else if (response.status === 404) {
          document.querySelector('#backinstockForm--Email').setAttribute('aria-describedby', 'backinstock-error')
          document.querySelector('#backInStock-form__message--error').classList.toggle('invisible')
          document.querySelector('#backInStock-form__message--error').classList.toggle('hidden')
          document.querySelector('#backInStock-form__message--error').classList.toggle('flex')

          if (document.querySelector('#backInStock-form__message--success').classList.contains('flex')) {
            document.querySelector('#backInStock-form__message--success').classList.toggle('invisible')
            document.querySelector('#backInStock-form__message--success').classList.toggle('hidden')
            document.querySelector('#backInStock-form__message--success').classList.toggle('flex')
          }
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  })
